import DivisionPage from "@/components/DivisionPage";
import { DIVISIONS } from "@/data/divisions";

export default function Transporte() {
  return <DivisionPage division={DIVISIONS.transporte} />;
}
